<thead #theadRef *ngIf="headerTemplate">
    <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
</thead>
<tbody *ngIf="bodyTemplate" [class.eui-table__loading]="loading" (cdkObserveContent)="onContentChanges()">
    <ng-container *ngFor="let row of rows; trackBy: trackByFn">
        <ng-template [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{ $implicit: row }"></ng-template>
    </ng-container>
</tbody>
<tfoot *ngIf="footerTemplate">
    <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
</tfoot>

<div #stickyHeaderRef *ngIf="hasStickyHeader" class="eui-table__sticky-header-container">
    <table class="eui-table {{ cssClasses }}">
        <thead>
            <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
        </thead>
    </table>
</div>
